const API_URL = process.env.REACT_APP_API_URL;

export const submitForm = async (formData) => {
  const response = await fetch(`${API_URL}/forms/book-now`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });

  return response.json();
};

export const getAllForms = async (page = 1, limit = 10) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_URL}/forms/all?page=${page}&limit=${limit}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.json();
};

export const deleteForm = async (id) => {
  console.log("API call to delete:", id);
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_URL}/forms/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  console.log("Delete response:", data);

  return data;
};

export const getDeletedBookings = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${API_URL}/forms/deleted`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch deleted bookings");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching deleted bookings:", error);
    return [];
  }
};

export const doneForm = async (id) => {
  console.log("API call to mark as done:", id);
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_URL}/forms/donebookings`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ formId: id }),
  });

  if (!response.ok) {
    console.error("Failed to mark booking as done:", response.status);
    return { success: false, message: "Failed to mark booking as done" };
  }

  const data = await response.json();
  console.log("Done response:", data);

  return data;
};

export const getDoneBookings = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${API_URL}/forms/done`, {
      // <-- Change `/donebookings` to `/done`
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch completed bookings");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching completed bookings:", error);
    return [];
  }
};
export const verifyDownPayment = async (id, status) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${API_URL}/forms/verify-down-payment/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    });

    const data = await response.json();
    console.log("Response:", data);

    if (!response.ok) {
      throw new Error(data.message || "Failed to verify down payment");
    }

    return data;
  } catch (error) {
    console.error("Error verifying down payment:", error);
    return { success: false, message: error.message };
  }
};

export const verifyFullPayment = async (id, status) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_URL}/forms/verify-full-payment/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ status }),
  });

  return response.json();
};
